<div class="d-flex">
  <div class="ms-5 me-5 {{ changeRequestStatus ? 'w-70' : 'w-100' }}">
    <div
      class="configuration-metadata-overview-form {{
        changeRequestStatus ? 'mt-5' : ''
      }} {{
        changeRequestStatus === EServiceChangeRequestStatus.IN_REDEVELOPMENT ||
        inReviewMode
          ? 'col-lg-5 pe-4 mx-auto '
          : 'col-lg-5 mx-auto mt-5'
      }} ">
      <div #errorMessageElement>
        <irembogov-irembo-section-message
          *ngIf="showConfigFormErrorMessage"
          [type]="formAlertContent.type"
          [title]="formAlertContent.title"
          [message]="
            formAlertContent.message
          "></irembogov-irembo-section-message>
      </div>

      <form
        [formGroup]="requestOverviewForm"
        (submit)="onFormSubmit()"
        *ngIf="changeRequest && changeRequest.serviceName">
        <fieldset [disabled]="inReviewMode">
          <legend class="d-none">Change Request Metadata</legend>
          <div class="mb-3">
            <h5 class="form-title mb-3">Service Details</h5>
            <div class="form-group">
              <label for="serviceName" class="form-label">
                Service Name
                <i
                  class="fa-solid fa-circle-info text-muted"
                  placement="top"
                  ngbTooltip="Name of service"></i>
              </label>
              <div class="input-group mb-3">
                <input
                  type="text"
                  class="form-control"
                  id="serviceName"
                  placeholder="Service Name"
                  formControlName="serviceName"
                  #serviceName />
              </div>
              <div
                class="form-error w-100 small text-danger"
                *ngIf="
                  requestOverviewForm.controls['serviceName'].touched &&
                  !requestOverviewForm.controls['serviceName'].valid &&
                  !inReviewMode
                ">
                Service name is required.
              </div>
            </div>

            <div class="row d-flex flex-wrap flex-md-nowrap flex-row">
              <div class="col-md-12">
                <div class="form-group">
                  <label
                    for="serviceSummary"
                    class="form-label d-flex justify-content-between align-items-center">
                    <span>
                      Enter Service Summary
                      <i
                        class="fa-solid fa-circle-info text-muted"
                        placement="top"
                        ngbTooltip="Summary of service"></i>
                    </span>

                    <button
                      type="button"
                      title="Switch between the Editor and Html"
                      class="btn btn-primary btn-sm"
                      (click)="hideShowHtml()">
                      {{ showHtmlCode ? 'Editor' : 'Html' }}
                    </button>
                  </label>
                  <div class="form-group mb-3">
                    <quill-editor
                      *ngIf="!showHtmlCode"
                      #editor
                      format="html"
                      [modules]="quillConfig"
                      class="custom-editor"
                      formControlName="serviceSummary"
                      [required]="true"
                      placeholder="Enter service summary">
                    </quill-editor>

                    <div>
                      <textarea
                        *ngIf="showHtmlCode"
                        class="htmlCode form-control"
                        row="10"
                        formControlName="serviceSummary"></textarea>
                    </div>

                    <small class="w-100 text-muted pt-2" *ngIf="!inReviewMode">
                      {{
                        wordCount(
                          requestOverviewForm.controls['serviceSummary'].value
                        )
                      }}
                      words
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="serviceSummary" class="form-label mb-3">
                    Service Summary Preview
                  </label>
                  <div class="card p-3 summary-preview">
                    <div
                      class="content-preview"
                      [innerHTML]="
                        requestOverviewForm.controls['serviceSummary'].value
                      "></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="categoryId" class="form-label">
                Service Category
                <i
                  class="fa-solid fa-circle-info text-muted"
                  placement="top"
                  ngbTooltip="Category of service"></i>
              </label>
              <div class="input-group mb-3">
                <ng-select
                  [readonly]="inReviewMode"
                  formControlName="categoryId"
                  [items]="serviceCategoriesBuffer"
                  [virtualScroll]="true"
                  [loading]="isLoadingServiceCategories"
                  bindLabel="name"
                  bindValue="id"
                  placeholder="Choose the service category"
                  class="form-control"
                  (search)="onSearchServiceCategory($event)"
                  #select>
                  <ng-template
                    ng-option-tmp
                    let-item="item"
                    let-index="index"
                    let-search="searchTerm">
                    <strong>{{ item.name }}</strong>
                    <span class="fst-italic">
                      (
                      <span class="text-muted">Keywords:</span>
                      {{
                        item.keywords && item.keywords.length > 15
                          ? (item.keywords | slice : 0 : 15) + '...'
                          : item?.keywords
                      }}
                      )
                    </span>
                  </ng-template>
                </ng-select>
              </div>
              <div
                class="form-error w-100 small text-danger"
                *ngIf="
                  requestOverviewForm.controls['categoryId'].touched &&
                  !requestOverviewForm.controls['categoryId'].valid &&
                  !inReviewMode
                ">
                Please select a service category.
              </div>
            </div>

            <div class="form-group mb-4">
              <label for="knowledgeBaseUrl" class="form-label">
                Knowledge base Article Url
                <i
                  class="fa-solid fa-circle-info text-muted"
                  placement="top"
                  ngbTooltip="Optional URL to knowledge base article for this service"></i>
              </label>
              <div class="input-group mb-3">
                <input
                  type="text"
                  class="form-control"
                  id="knowledgeBaseUrl"
                  placeholder="Knowledge base Article Url"
                  formControlName="knowledgeBaseUrl"
                  #knowledgeBaseUrl />
              </div>
              <div
                class="form-error w-100 small text-danger"
                *ngIf="
                  requestOverviewForm.controls['knowledgeBaseUrl'].touched &&
                  !requestOverviewForm.controls['knowledgeBaseUrl'].valid &&
                  !inReviewMode
                ">
                <span
                  *ngIf="
                    requestOverviewForm.controls['knowledgeBaseUrl'].hasError(
                      'invalidUrl'
                    )
                  ">
                  Please enter a valid URL.
                </span>
                <span
                  *ngIf="
                    requestOverviewForm.controls['knowledgeBaseUrl'].hasError(
                      'invalidProtocol'
                    )
                  ">
                  URL must use http or https protocol.
                </span>
              </div>
            </div>

            <div class="form-group mb-3 service-availability">
              <label class="form-label">Service Availability</label>
              <small class="text-muted d-block mb-4">
                Select who can apply for this service
              </small>

              <div class="availability-card">
                <!-- Individual Section -->
                <div class="availability-section px-4 py-4">
                  <div
                    class="d-flex justify-content-between align-items-center">
                    <span class="fw-semibold">Individual</span>
                    <div class="form-check form-switch mb-0">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="individualEnabled"
                        formControlName="individualEnabled"
                        (change)="onIndividualToggleChange()" />
                    </div>
                  </div>

                  <div
                    *ngIf="requestOverviewForm.get('individualEnabled')?.value"
                    class="individual-subtypes mt-1 p-3">
                    <!-- 1. Verified individuals (always checked, disabled) -->
                    <div class="d-flex align-items-start gap-2">
                      <input
                        class="form-check-input mt-1 flex-shrink-0"
                        type="checkbox"
                        [checked]="true"
                        [disabled]="true" />
                      <div>
                        <div class="subtype-label fw-semibold">
                          Verified individuals
                        </div>
                        <div class="text-muted small">
                          Users with NIDA-linked accounts
                        </div>
                      </div>
                    </div>

                    <!-- 2. Non-verified individuals -->
                    <div class="d-flex align-items-start gap-2 mt-3">
                      <input
                        class="form-check-input mt-1 flex-shrink-0"
                        type="checkbox"
                        value="INDIVIDUAL_NON_VERIFIED"
                        (change)="onIndividualApplicantTypeChange($event)"
                        [checked]="
                          requestOverviewForm
                            .get('individualApplicantTypes')
                            ?.value?.includes('INDIVIDUAL_NON_VERIFIED')
                        " />
                      <div>
                        <div class="subtype-label fw-semibold">
                          Non-verified individuals
                        </div>
                        <div class="text-muted small">
                          Users without a verified profile
                        </div>
                      </div>
                    </div>

                    <!-- 3. Anonymous users -->
                    <div class="d-flex align-items-start gap-2 mt-3">
                      <input
                        class="form-check-input mt-1 flex-shrink-0"
                        type="checkbox"
                        value="ANONYMOUS"
                        (change)="onIndividualApplicantTypeChange($event)"
                        [checked]="
                          requestOverviewForm
                            .get('individualApplicantTypes')
                            ?.value?.includes('ANONYMOUS')
                        " />
                      <div>
                        <div class="subtype-label fw-semibold">
                          Anonymous users
                        </div>
                        <div class="text-muted small">
                          Guest users applying without login
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <hr class="my-0 mx-4" />

                <!-- Business Section -->
                <div class="availability-section business-section px-4 py-4">
                  <div
                    class="d-flex justify-content-between align-items-center">
                    <span class="fw-semibold">Business</span>
                    <div class="form-check form-switch mb-0">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="businessEnabled"
                        formControlName="businessEnabled" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group mt-3">
              <label class="form-label d-block">
                Initial RFA Enforcement
                <i
                  class="fa-solid fa-circle-info text-muted"
                  placement="top"
                  ngbTooltip="When enabled, applicants must complete RFA (Request for Approval) before creating a new application"></i>
              </label>
              <small class="text-muted d-block mb-2">
                Enable this option to enforce the loading of RFA at the start of
                the application process.
              </small>
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="initialRfaEnforced"
                  formControlName="initialRfaEnforced" />
                <label class="form-check-label" for="initialRfaEnforced">
                  {{
                    requestOverviewForm.get('initialRfaEnforced')?.value
                      ? 'Enabled'
                      : 'Disabled'
                  }}
                </label>
              </div>
            </div>
          </div>
          <div class="text-end" *ngIf="!inReviewMode">
            <button
              class="btn btn-primary mt-1 mx-auto px-5"
              type="submit"
              [disabled]="
                isLoading ||
                isLoadingServiceCategories ||
                requestOverviewForm.invalid
              ">
              <div
                *ngIf="isLoading"
                class="spinner-border spinner-border-sm mr-2"
                role="status"></div>
              Continue
            </button>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
  <div
    class="pt-5 ms-3 me-3 w-30"
    *ngIf="
      changeRequest?.status === EServiceChangeRequestStatus.IN_REDEVELOPMENT
    ">
    <irembogov-service-change-request-feedback-handler-widget
      *ngIf="changeRequest"
      [changeRequestId]="changeRequest.id ?? ''"
      [serviceChangeRequestSection]="
        EServiceChangeRequestSection.OVERVIEW
      "></irembogov-service-change-request-feedback-handler-widget>
  </div>
</div>
